export default __webpack_public_path__ + "static/favicon-16x16.png";